import { apiRequest, handleApiError } from "../utils/api"

import { getUserIdToken } from "../utils/auth"

export const createUser = async token => {
  const query = `{createUser{success, isNewUser, error{message, display, code}}}`
  const response = await apiRequest("client", query, token)
  handleApiError(response, false, "createUser")
  return response
}

export const getEntries = async token => {
  const query = `{userEntries{key, date, type, text, image, pinned}}`
  const response = await apiRequest("client", query, token)
  handleApiError(response, false, "userEntries")
  if (response.data) {
    const { userEntries: entries } = response.data
    return entries
  }
  return []
}

export const createEntry = async ({ date, image, text, type, pinned } = {}) => {
  const token = getUserIdToken()
  const query = `mutation{createEntry(date: "${date}", image: "${image}", text: "${text}", type: "${type}", pinned: ${pinned}) {success, id, error}}`
  const response = await apiRequest("client", query, token)
  handleApiError(response, false, "createEntry")
  if (response.data) {
    const { createEntry: data } = response.data
    return data
  }
  return response.data
}

export const updateEntry = async (
  key,
  { date, image, text, type, pinned } = {}
) => {
  const token = getUserIdToken()
  const query = `mutation{updateEntry(key: "${key}", date: "${date}", image: "${image}", text: "${text}", type: "${type}", pinned: ${pinned}) {success, key}}`
  const response = await apiRequest("client", query, token)
  handleApiError(response, false, "updateEntry")
  if (response.data) {
    const { updateEntry: data } = response.data
    return data
  }
  return response.data
}

export const deleteEntry = async key => {
  const token = getUserIdToken()
  const query = `mutation{deleteEntry(key: "${key}") {success, key}}`
  const response = await apiRequest("client", query, token)
  handleApiError(response, false, "deleteEntry")
  if (response.data) {
    const { deleteEntry: data } = response.data
    return data
  }
  return response.data
}
